module.exports = __webpack_public_path__ + "media/images/landing/useek_logo_big-7b1b634d02ea6513e8222dbeaf4118a3.png";